const hex = (colors) => colors;
export const MAP_PALETTES = [
    { id: 'modern-light', name: 'Orbit', colors: [] },
    {
        id: 'ocean',
        name: 'Oceano',
        colors: hex(['#2857a4', '#237fb0', '#178f91', '#506cb4', '#357086', '#486297']),
    },
    {
        id: 'forest',
        name: 'Floresta',
        colors: hex(['#287444', '#508438', '#2b856e', '#678437', '#387967', '#548066']),
    },
    {
        id: 'sunset',
        name: 'Pôr do sol',
        colors: hex(['#b34e3f', '#a36825', '#a94171', '#966629', '#9b527c', '#bd5c32']),
    },
    {
        id: 'graphite',
        name: 'Grafite',
        colors: hex(['#455268', '#55647a', '#647089', '#455268', '#55647a', '#647089']),
    },
    {
        id: 'midnight',
        name: 'Meia-noite',
        colors: hex(['#38bdf8', '#a78bfa', '#f472b6', '#34d399', '#fbbf24', '#60a5fa']),
        canvas: { background: '#0b1026', dark: true },
    },
    {
        id: 'neon',
        name: 'Neon',
        colors: hex(['#22d3ee', '#f0abfc', '#a3e635', '#fb7185', '#facc15', '#818cf8']),
        canvas: { background: '#09090b', dark: true },
    },
    {
        id: 'indigo',
        name: 'Anil',
        colors: hex(['#fde68a', '#bbf7d0', '#fecaca', '#bae6fd', '#e9d5ff', '#fed7aa']),
        canvas: { background: '#312e81', dark: true },
    },
    {
        id: 'chalkboard',
        name: 'Lousa',
        colors: hex(['#fef08a', '#bef264', '#fda4af', '#7dd3fc', '#fdba74', '#e9d5ff']),
        canvas: { background: '#1f3a2e', dark: true },
    },
    {
        id: 'blush',
        name: 'Rosado',
        colors: hex(['#be185d', '#7c3aed', '#0f766e', '#c2410c', '#1d4ed8', '#a16207']),
        canvas: { background: '#fde2e4', dark: false },
    },
    {
        id: 'paper',
        name: 'Papel',
        colors: hex(['#92400e', '#1e3a8a', '#9f1239', '#3f6212', '#57534e', '#7c2d12']),
        canvas: { background: '#f6efe0', dark: false },
    },
    {
        id: 'mint',
        name: 'Menta',
        colors: hex(['#047857', '#0e7490', '#7c3aed', '#be123c', '#b45309', '#1d4ed8']),
        canvas: { background: '#e3f6ee', dark: false },
    },
    {
        id: 'sky',
        name: 'Céu',
        colors: hex(['#1d4ed8', '#0891b2', '#7c3aed', '#db2777', '#059669', '#ea580c']),
        canvas: { background: '#e6f0ff', dark: false },
    },
];
export function mapTheme(themeId) {
    return MAP_PALETTES.find((palette) => palette.id === themeId);
}
export function mapPaletteColor(themeId, depth) {
    const colors = mapTheme(themeId)?.colors;
    if (colors === undefined || colors.length === 0)
        return undefined;
    return colors[depth % colors.length];
}
/** The page a map is drawn on, or `undefined` for a theme that uses the app's own background. */
export function mapCanvas(themeId) {
    return mapTheme(themeId)?.canvas;
}
//# sourceMappingURL=palettes.js.map